<template>
  <sidebar-row border-bottom>
    <v-row no-gutters align="center" @mouseleave="onHover(false)" @mouseenter="onHover(true)">
      <v-col cols="auto" class="py-3 text-left">
        <p style="font-size: 12px; color: #202124" class="ma-0 pl-1">
          {{ name }}
        </p>
        <italic-subheader class="pl-1" :straight-text="subtitle" style="font-size: 10px !important;" />
      </v-col>
      <v-spacer />
      <v-col cols="auto">
        <v-icon size="18" @click="zoomToFeature"> mdi-magnify </v-icon>
        <dots-menu
          :items="dotsItems"
          @deleteRelation="openDeleteDialog"
          @openFeatureCard="openFeatureCard"
          font-size="18px"
        />
      </v-col>
    </v-row>
    <main-dialog
      v-if="isDialogLoaded"
      :is-visible.sync="isDialogVisible"
      :title="$i18n.t('dialog.title.deleteRelation')"
      :body="$i18n.t('dialog.body.deleteRelationConfirmation', relation)"
      @agree="handleRelationDelete"
      :loading="isDialogLoading"
      agree-text="dialog.agreeDelete"
    />
  </sidebar-row>
</template>
<script>
import { call, get } from 'vuex-pathify';
import DotsMenu from '@/components/DotsMenu';
import ItalicSubheader from '@/components/ItalicSubheader';
import SidebarRow from '@/components/SidebarRow';
export default {
  name: 'TheRelation',
  components: { DotsMenu, ItalicSubheader, MainDialog: () => import('@/components/MainDialog'), SidebarRow },
  props: {
    featureId: {
      type: [String, Number],
      required: true,
    },
    dataSourceName: {
      type: String,
      required: true,
    },
    relation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    projectElements: get('layers/project@layers'),
    projectLayers() {
      return this.$_getFlatGroupsLayers(this.projectElements).layers;
    },
    users: get('users/users'),
    dotsItems() {
      return [
        { name: 'deleteRelation' },
        {
          name: 'openFeatureCard',
          ...(this.projectLayers.findIndex(layer => layer.data_source_name === this.relation.data_source_name) < 0
            ? { disabled: true, tooltip: this.$i18n.t('snackbar.noLayerInProjectToPush') }
            : {}),
        },
      ];
    },
    name() {
      const { data_source_verbose_name, feature_id, feature_desc_attribute_value } = this.relation;
      const attributeValue =
        feature_desc_attribute_value || feature_desc_attribute_value === 0 || feature_desc_attribute_value === null
          ? feature_desc_attribute_value
          : feature_id;
      return `${data_source_verbose_name}: ${attributeValue}`;
    },
    subtitle() {
      const { assigned_at, assigned_by } = this.relation;
      const date = this.$dayjs(assigned_at).format('L');
      const time = this.$dayjs(assigned_at).format('LT');
      const dateTime = `${date}, ${time}`;
      const userName = this.users[assigned_by]?.name;
      return userName ? `${userName}, ${dateTime}` : `${dateTime}`;
    },
  },
  data: () => ({
    isDialogLoaded: false,
    isDialogLoading: false,
    isDialogVisible: false,
  }),
  methods: {
    deleteRelation: call('relations/deleteRelation'),
    getLayerFeature: call('layers/getLayerFeature'),
    async handleRelationDelete() {
      this.isDialogLoading = true;
      try {
        const payload = {
          data_source_name: this.dataSourceName,
          feature_id: this.featureId,
          features: [this.relation],
        };
        await this.deleteRelation(payload);
        this.$root.$emit('refreshTableData');
        this.$root.$emit('refreshFormData');
        const layersIds = this.projectLayers
          .filter(layer => layer.data_source_name === this.dataSourceName)
          .map(layer => layer.id);
        if (layersIds?.length) this.$root.$emit('updateLegendStylesCounts', { layersIds });
        this.isDialogLoading = false;
        this.isDialogVisible = false;
      } catch {
        this.isDialogLoading = false;
      }
    },
    onHover(value) {
      this.$root.$emit('toggleFeatureHover', this.relation, value);
    },
    openDeleteDialog() {
      this.isDialogLoaded = true;
      this.isDialogVisible = true;
    },
    async openFeatureCard() {
      const { data_source_name, feature_id } = this.relation;
      const layersIds = this.projectLayers
        .filter(layer => layer.data_source_name === data_source_name)
        .map(layer => layer.id);
      for (const layerId of layersIds) {
        try {
          const r = await this.getLayerFeature({
            layer_id: layerId,
            feature_id: feature_id,
            skipDefaultErrorHandler: true,
          });
          if (r?.id == feature_id) {
            this.$router.push({
              name: 'layerFeature',
              params: { lid: layerId, fid: feature_id },
            });
            return;
          }
        } catch {
          //
        }
      }
      this.$store.set('snackbar/PUSH_MESSAGE!', {
        message: this.$i18n.t('snackbar.noLayerInProjectToPush'),
      });
    },
    zoomToFeature() {
      const geometry = JSON.parse(JSON.stringify(this.relation.geometry));
      geometry.crs = { properties: { name: this.$_config.defaultEpsg }, type: 'name' };
      this.$root.$emit('createGeomAndFitView', geometry);
    },
  },
};
</script>
